import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';

import BrzwDatePicker from '../brzw_date_picker';

import './date_time_picker.scss';

const CLASS_NAME = 'bulk-date-time-picker';

const VISIBLE_DATE_FORMAT = 'MMM DD, YYYY';
const VISIBLE_TIME_FORMAT = 'hh:mm a';

const renderCustomPickerToggle = (iconName, value) => (
  <div className={`${CLASS_NAME}__toggle-wrapper`}>
    <div className={`${CLASS_NAME}__toggle-left-side`}>
      <div className={classnames(`${CLASS_NAME}__toggle-calendar`, `icon-${iconName}`)} />
      <span className={`${CLASS_NAME}__toggle-label`}>{value}</span>
    </div>
    <div className={classnames(`${CLASS_NAME}__toggle-icon`, 'icon-down')} />
  </div>
);

const DateTimeSelection = ({ onDateChange, onTimeChange, selectedDate, selectedTime, timeZone }) => {
  const today = moment();
  const todayCopy = today.clone();
  const maxTime = today.clone();
  const isSameDay = today.isSame(selectedDate, 'day');

  return <div className={`${CLASS_NAME}__date-selection`}>
    <div className={`${CLASS_NAME}__pickers`}>
      <BrzwDatePicker
        customInput={renderCustomPickerToggle('calendar', selectedDate.format(VISIBLE_DATE_FORMAT))}
        dateFormat={VISIBLE_DATE_FORMAT}
        futureOnly
        inputClassName={`${CLASS_NAME}__date-picker`}
        maxDate={maxTime.add(2, 'weeks')}
        onChange={onDateChange}
        selected={selectedDate}
      />
      <BrzwDatePicker
        customInput={renderCustomPickerToggle('clock', selectedTime.format(VISIBLE_TIME_FORMAT))}
        dateFormat={VISIBLE_TIME_FORMAT}
        futureOnly
        inputClassName={`${CLASS_NAME}__time-picker`}
        maxTime={todayCopy.endOf('day')}
        minTime={isSameDay ? today : today.startOf('day')}
        onChange={onTimeChange}
        selected={selectedTime}
        showTimeSelect
        showTimeSelectOnly
      />
    </div>
    <span className={`${CLASS_NAME}__time-zone`}>{timeZone}</span>
  </div>
};

DateTimeSelection.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  selectedDate: PropTypes.shape({}),
  selectedTime: PropTypes.shape({}),
  timeZone: PropTypes.string,
};

export default DateTimeSelection;
